import { mapActions, mapGetters, mapMutations } from 'vuex';
import { getProductPriceTitle, resolveProductImage, routeToProduct, PRODUCT_TYPE } from '@/helpers';
import IconMinus from '@/components/icons/IconMinus.vue';
import IconPlus from '@/components/icons/IconPlus.vue';
import IconDelete from '@/components/icons/IconDelete.vue';
import saleRows from '@/mixins/sale-rows';

export default {
  name: 'BasketCard',
  mixins: [saleRows],
  components: { IconDelete, IconPlus, IconMinus },
  props: {
    basketHasPromotion: {
      type: Boolean,
      default: false
    },
    product: {
      type: Object,
      default: () => ({})
    },
    productType: {
      type: String,
      default: PRODUCT_TYPE.PRODUCT
    },
    syncPriceProductId: {
      type: [Number, null],
      default: null
    }
  },
  emits: ['update'],
  data() {
    return {
      PRODUCT_TYPE,
      selectedCount: 1,
      width: window.innerWidth,
      isTrySyncPrice: false
    };
  },
  mounted() {},
  watch: {
    syncPriceProductId: {
      immediate: false,
      handler(newVal) {
        if (newVal === null && this.isTrySyncPrice) {
          this.isTrySyncPrice = false;
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      isSamplesLoading: 'samples/isSamplesLoading',
      isGiftsLoading: 'gifts/isGiftsLoading'
    }),
    isLoadingSyncProductPrice() {
      return this.syncPriceProductId === this.product.id || this.isTrySyncPrice;
    },
    isShowOldUnitPrice() {
      return this.rowOldUnitPrice(this.product) !== null;
    },
    isShowOldSum() {
      return this.rowOldSum(this.product) !== null;
    }
  },
  methods: {
    getProductPriceTitle,
    routeToProduct,
    resolveProductImage,
    ...mapMutations({
      increment: 'basket/INCREMENT_BASKET_LIST_COUNT',
      decrement: 'basket/DECREMENT_BASKET_LIST_COUNT',
      setCount: 'basket/SET_BASKET_LIST_COUNT',
      remove: 'basket/REMOVE_ITEM_FROM_BASKET',
      setRemovedSampler: 'samples/SET_REMOVED_SAMPLER'
    }),
    ...mapActions({
      removeSelectedGift: 'gifts/REMOVE_SELECTED_GIFT'
    }),
    onRemove(product) {
      this.remove(product);
      this.$emit('update');
    },
    onRemoveSampler(id) {
      console.log('onRemoveSampler', id);
      this.setRemovedSampler(id);
    },
    onRemoveGift() {
      if (this.product._giftGroupId == null || this.product._productPriceId == null) return;
      this.removeSelectedGift({
        giftGroupId: this.product._giftGroupId,
        productPriceId: this.product._productPriceId
      });
    },

    onChangeCount(type, count = 1) {
      this.isTrySyncPrice = true;
      if (type === 'increment') {
        this.increment(this.product);
      } else if (type === 'decrement') {
        this.decrement(this.product);
      } else {
        if (count) {
          this.setCount({
            product: this.product,
            select_count: parseInt(count)
          });
        }
      }
      this.$emit('update');
    }
  },
  beforeDestroy() {}
};
